import { render, staticRenderFns } from "./AlimentosEInsumos.vue?vue&type=template&id=4c65fffa&"
import script from "./AlimentosEInsumos.vue?vue&type=script&lang=js&"
export * from "./AlimentosEInsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports